module.exports = __webpack_public_path__ + "img/Design_Development.377b69df.png";